import useToken from 'modules/auth/atoms/use-token';
import React, {useState} from 'react';
import {IoPrint} from 'react-icons/io5';
import {baseURL} from 'shared/hooks/use-api';
import IconButton from 'shared/migration-components/icon-button';

interface Props {
  orderId: string;
}

const DownloadReceiptButton: React.FC<Props> = ({orderId}) => {
  const {token} = useToken();
  const [loading, setLoading] = useState(false);

  const handleDownloadReceipt = async () => {
    setLoading(true);
    const response = await fetch(`${baseURL}/orders/${orderId}/receipt`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setLoading(false);

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  };

  return (
    <IconButton
      icon={<IoPrint />}
      backgroundColor="rgba(0, 0, 0, .6)"
      color="white"
      label="Imprimir pedido"
      onClick={handleDownloadReceipt}
      {...{loading}}
    />
  );
};

export default DownloadReceiptButton;
